import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=37e838f6&scoped=true"
import script from "./MainDashboard.vue?vue&type=script&lang=ts"
export * from "./MainDashboard.vue?vue&type=script&lang=ts"
import style0 from "./MainDashboard.vue?vue&type=style&index=0&id=37e838f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e838f6",
  null
  
)

export default component.exports